import React, { Component, Fragment } from 'react'
import { Input } from 'hljd'
import { observer } from 'mobx-react'
const TextArea = Input.TextArea
@observer
export default class extends Component {
  render() {
    const { content, changeField, initContent } = this.props.store
    return (
      <Fragment>
        <div style={{ color: '#333', fontSize: 14, marginBottom: 12 }}>
          <p style={{ lineHeight: '28px' }}>小贴士：</p>
          <p style={{ lineHeight: '28px' }}>
            (1)
            为了吸引和转化潜在用户，建议不要直接询问联系方式，而是以展示促销、优质活动、优质案例为主，吸引用户进一步沟通
          </p>
          <p style={{ lineHeight: '28px' }}>
            (2) 默认文案中 {`{婚礼纪用户名}`}{' '}
            是一个特殊标记，在发送后会自动替换成收到消息用户的婚礼纪用户名，建议使用以增强亲切感
          </p>
        </div>
        <TextArea
          style={{ width: 338, height: 154 }}
          placeholder="Hi  {婚礼纪用户名}&#10;店铺8月进行大促销啦，小主收藏的套餐都有8折以上的降价呦~  咨询就有专属优惠券"
          autoSize={{ minRows: 6, maxRows: 6 }}
          value={content}
          onChange={changeField('content')}
          onFocus={initContent}
          maxLength={120}
        />
        <span style={{ marginLeft: 10 }}>{content.length}/120</span>
      </Fragment>
    )
  }
}
